// extracted by mini-css-extract-plugin
export var measureBox = "_5k-0";